
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forkliftestimates/privacy-policy",
      function () {
        return require("private-next-pages/forkliftestimates/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forkliftestimates/privacy-policy"])
      });
    }
  